import React from "react";

const MenuXButton = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1283_24482)">
        <ellipse cx="31.9863" cy="30.001" rx="23" ry="22.9993" fill="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.6529 30.0275L39.3039 24.3765C39.4154 24.265 39.5039 24.1327 39.5643 23.9871C39.6246 23.8415 39.6557 23.6854 39.6558 23.5278C39.6558 23.3702 39.6248 23.2141 39.5645 23.0684C39.5042 22.9228 39.4159 22.7905 39.3044 22.679C39.193 22.5675 39.0607 22.479 38.9151 22.4187C38.7695 22.3583 38.6134 22.3272 38.4558 22.3271C38.2982 22.3271 38.1421 22.3581 37.9964 22.4184C37.8508 22.4787 37.7184 22.567 37.6069 22.6785L31.9559 28.3305L26.3039 22.6785C26.0763 22.4658 25.775 22.35 25.4635 22.3553C25.1521 22.3607 24.8549 22.4868 24.6347 22.7072C24.4145 22.9275 24.2885 23.2248 24.2833 23.5362C24.2781 23.8477 24.3942 24.1489 24.6069 24.3765L30.2589 30.0275L24.6069 35.6785C24.4399 35.8467 24.3263 36.0605 24.2805 36.2931C24.2347 36.5256 24.2586 36.7666 24.3494 36.9856C24.4401 37.2046 24.5936 37.3919 24.7905 37.5239C24.9874 37.6559 25.2189 37.7267 25.4559 37.7275C25.7629 37.7275 26.0699 37.6105 26.3039 37.3765L31.9559 31.7245L37.6069 37.3765C37.7182 37.4881 37.8505 37.5767 37.9961 37.6372C38.1417 37.6976 38.2978 37.7287 38.4554 37.7287C38.6131 37.7287 38.7692 37.6976 38.9148 37.6372C39.0604 37.5767 39.1926 37.4881 39.3039 37.3765C39.4155 37.265 39.504 37.1327 39.5644 36.987C39.6248 36.8413 39.6559 36.6852 39.6559 36.5275C39.6559 36.3698 39.6248 36.2136 39.5644 36.0679C39.504 35.9223 39.4155 35.7899 39.3039 35.6785L33.6529 30.0275Z"
        fill="#404244"
      />
      <defs>
        <filter
          id="filter0_d_1283_24482"
          x="0.553031"
          y="0.211243"
          width="62.8666"
          height="62.8651"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.64283" />
          <feGaussianBlur stdDeviation="4.21665" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1283_24482"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1283_24482"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default MenuXButton;
